import { Directive, Input, OnDestroy, output } from '@angular/core';
import { auditTime, fromEvent, Subscription } from 'rxjs';

@Directive({
  selector: '[blazeChatInfiniteScroll]',
})
export class ChatInfiniteScrollDirective implements OnDestroy {
  scrollBottom = output();
  scrollTop = output();

  @Input() scrollThrottle = 250;

  private subscription = Subscription.EMPTY;

  @Input() set viewport(element: HTMLElement | undefined) {
    if (!element) {
      this.subscription.unsubscribe();
      return;
    }

    this.subscribeToScroll(element);
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  private subscribeToScroll(element: HTMLElement): void {
    this.subscription.unsubscribe();

    element.scrollTop = element.scrollHeight;

    this.subscription = fromEvent(element, 'scroll')
      .pipe(auditTime(this.scrollThrottle))
      .subscribe(() => {
        if (element.scrollTop === 0) {
          this.scrollTop.emit();
        }
        if (element.scrollTop === element.scrollHeight - element.clientHeight) {
          this.scrollBottom.emit();
        }
      });
  }
}
